import * as Types from '../../doorhub-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminViewLockerFragment = { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, imageFileId?: string | null, pickupBefore?: any | null } | null };

export type AdminViewQueryVariables = Types.Exact<{
  systemId: Types.Scalars['ID'];
}>;


export type AdminViewQuery = { __typename?: 'Query', lockersystem?: { __typename?: 'Lockersystem', id: string, name?: string | null, lainaamoTranslations: Array<{ __typename?: 'TranslationItem', id: string, key: string, variables: Array<string>, language: string, default: string, translation?: string | null }>, lockerGroups: Array<{ __typename?: 'LockerGroup', id: string, name: string, lockerUnits: Array<{ __typename?: 'LockerUnit', id?: string | null, lockerNodes: Array<{ __typename?: 'LockerNode', id?: string | null, leftUpDoorVisible?: boolean | null, rightUpDoorVisible?: boolean | null, leftDownDoorVisible?: boolean | null, rightDownDoorVisible?: boolean | null, leftUpLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, imageFileId?: string | null, pickupBefore?: any | null } | null } | null, rightUpLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, imageFileId?: string | null, pickupBefore?: any | null } | null } | null, leftDownLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, imageFileId?: string | null, pickupBefore?: any | null } | null } | null, rightDownLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, imageFileId?: string | null, pickupBefore?: any | null } | null } | null }> }>, lockers: Array<{ __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, imageFileId?: string | null, pickupBefore?: any | null } | null }> }>, items: { __typename?: 'LockersystemItemsConnection', items: Array<{ __typename?: 'Item', id: string, name?: string | null, rentable?: boolean | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', name?: string | null, userName?: string | null, gmail?: string | null } | null } | null, locker?: { __typename?: 'Locker', name: number, lockerGroup?: { __typename?: 'LockerGroup', id: string, name: string } | null } | null }> }, activeDeliveries: { __typename?: 'LockersystemActiveDeliveriesConnection', deliveries: Array<{ __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null, useDeliveryCodeBefore?: any | null, deliveryCodeUsedAt?: any | null, createdAt?: any | null, whoCanPickup: Array<{ __typename?: 'User', id: string, name?: string | null, userName?: string | null, email?: string | null, identityCode?: string | null }>, userWhoDelivered?: { __typename?: 'User', id: string, name?: string | null, userName?: string | null, email?: string | null } | null, locker?: { __typename?: 'Locker', name: number, lockerGroup?: { __typename?: 'LockerGroup', id: string, name: string } | null } | null }> }, activeRentings: { __typename?: 'LockersystemActiveRentingsConnection', rentings: Array<{ __typename?: 'Renting', id: string, returnItemBefore?: any | null, state: Types.RentingState, user?: { __typename?: 'User', id: string, gmail?: string | null, name?: string | null, userName?: string | null } | null, item?: { __typename?: 'Item', name?: string | null } | null, locker: { __typename?: 'Locker', id: string, name: number, lockerGroup?: { __typename?: 'LockerGroup', id: string, name: string } | null } }> }, itemGroups: Array<{ __typename?: 'ItemGroup', id: string, lockersystemId: string, name: string, maxRentingsPerUser?: number | null, maxRentingsPerUserEnabled: boolean }> } | null };

export type InterruptDeliveryMutationVariables = Types.Exact<{
  deliveryId: Types.Scalars['ID'];
}>;


export type InterruptDeliveryMutation = { __typename?: 'Mutation', interruptDelivery: { __typename?: 'InterruptDeliveryResponse', delivery: { __typename?: 'Delivery', id: string, pickupCode?: string | null, pickupBefore?: any | null, usePickupCodeBefore?: any | null } } };

export type InterruptRentingMutationVariables = Types.Exact<{
  rentingId: Types.Scalars['ID'];
}>;


export type InterruptRentingMutation = { __typename?: 'Mutation', interruptRenting: { __typename?: 'InterruptRentingResponse', renting: { __typename?: 'Renting', id: string, returnCode?: string | null, returnCodeUsedAt?: any | null, useReturnCodeBefore?: any | null } } };

export type PlaceItemToLockerMutationVariables = Types.Exact<{
  itemId: Types.Scalars['ID'];
  lockerId: Types.Scalars['ID'];
}>;


export type PlaceItemToLockerMutation = { __typename?: 'Mutation', placeItemToLocker: { __typename?: 'PlaceItemToLockerResponse', item: { __typename?: 'Item', id: string, creationCode?: string | null, creationCodeUsedAt?: any | null, useCreationCodeBefore?: any | null } } };

export type DeleteItemMutationVariables = Types.Exact<{
  itemId: Types.Scalars['ID'];
}>;


export type DeleteItemMutation = { __typename?: 'Mutation', deleteItem: { __typename?: 'DeleteItemResponse', item: { __typename?: 'Item', id: string, deletedAt?: any | null } } };

export type RemoveItemCodeQueryVariables = Types.Exact<{
  itemId: Types.Scalars['ID'];
}>;


export type RemoveItemCodeQuery = { __typename?: 'Query', item?: { __typename?: 'Item', id: string, removeCode?: string | null, removeCodeUsedAt?: any | null, useRemoveCodeBefore?: any | null } | null };

export type InterruptDeliveryCodeQueryVariables = Types.Exact<{
  deliveryId: Types.Scalars['ID'];
}>;


export type InterruptDeliveryCodeQuery = { __typename?: 'Query', delivery?: { __typename?: 'Delivery', id: string, interruptCode?: string | null, interruptCodeUsedAt?: any | null, useInterruptCodeBefore?: any | null } | null };

export type CreateItemMutationVariables = Types.Exact<{
  input: Types.CreateItem;
}>;


export type CreateItemMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateItemResponse', item?: { __typename?: 'Item', id: string, available?: boolean | null, locker?: { __typename?: 'Locker', id: string, item?: { __typename?: 'Item', id: string } | null } | null } | null } };

export type CreateItemCodeQueryVariables = Types.Exact<{
  itemId: Types.Scalars['ID'];
}>;


export type CreateItemCodeQuery = { __typename?: 'Query', item?: { __typename?: 'Item', id: string, creationCode?: string | null, creationCodeUsedAt?: any | null, useCreationCodeBefore?: any | null } | null };

export type UpdateItemMutationVariables = Types.Exact<{
  input: Types.UpdateItem;
}>;


export type UpdateItemMutation = { __typename?: 'Mutation', updateItem: { __typename?: 'UpdateItemResponse', item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, rentingTime?: number | null, rentable?: boolean | null, needsPermit?: boolean | null, emailAdminWhenReturned?: boolean | null, available?: boolean | null, itemGroupId?: string | null, itemGroup?: { __typename?: 'ItemGroup', id: string, name: string } | null, locker?: { __typename?: 'Locker', id: string, name: number, lockerGroup?: { __typename?: 'LockerGroup', id: string, name: string } | null } | null } | null } };

export type ChangeLanguageMutationVariables = Types.Exact<{
  input: Types.ChangeLanguage;
}>;


export type ChangeLanguageMutation = { __typename?: 'Mutation', changeUserDefaultLanguage?: { __typename?: 'ChangeLanguageResponse', user?: { __typename?: 'User', id: string, language?: string | null } | null } | null };

export type UpdateTranslationMutationVariables = Types.Exact<{
  input: Types.UpdateTranslation;
}>;


export type UpdateTranslationMutation = { __typename?: 'Mutation', updateTranslation: { __typename?: 'UpdateTranslationResponse', lockersystemId?: string | null, translation?: { __typename?: 'Translation', id: string, key: string, translation: string, language: string } | null } };

export type UpdateRentingMutationVariables = Types.Exact<{
  input: Types.UpdateRenting;
}>;


export type UpdateRentingMutation = { __typename?: 'Mutation', updateRenting: { __typename?: 'UpdateRentingResponse', renting: { __typename?: 'Renting', id: string, returnItemBefore?: any | null } } };

export type TransferRentingMutationVariables = Types.Exact<{
  input: Types.TransferRenting;
}>;


export type TransferRentingMutation = { __typename?: 'Mutation', transferRenting: { __typename?: 'TransferRentingResponse', renting: { __typename?: 'Renting', id: string, user?: { __typename?: 'User', id: string, name?: string | null, userName?: string | null, gmail?: string | null } | null } } };

export type SearchItemsQueryVariables = Types.Exact<{
  opt: Types.SearchItemsOptions;
}>;


export type SearchItemsQuery = { __typename?: 'Query', items: { __typename?: 'ItemsConnection', items: Array<{ __typename?: 'Item', id: string, name?: string | null, description?: string | null, rentingTime?: number | null, rentable?: boolean | null, needsPermit?: boolean | null, emailAdminWhenReturned?: boolean | null, available?: boolean | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, permitGiven?: boolean | null, user?: { __typename?: 'User', name?: string | null, userName?: string | null, gmail?: string | null } | null } | null, itemGroup?: { __typename?: 'ItemGroup', id: string, name: string } | null, locker?: { __typename?: 'Locker', id: string, name: number, lockerGroup?: { __typename?: 'LockerGroup', id: string, name: string } | null } | null }> } };

export type GivePermitMutationVariables = Types.Exact<{
  input: Types.GivePermit;
}>;


export type GivePermitMutation = { __typename?: 'Mutation', givePermit: { __typename?: 'GivePermitResponse', renting: { __typename?: 'Renting', id: string, state: Types.RentingState } } };

export type DeclinePermitMutationVariables = Types.Exact<{
  input: Types.DeclinePermit;
}>;


export type DeclinePermitMutation = { __typename?: 'Mutation', declinePermit: { __typename?: 'DeclinePermitResponse', renting: { __typename?: 'Renting', id: string, state: Types.RentingState } } };

export type EditItemScreenQueryVariables = Types.Exact<{
  itemId: Types.Scalars['ID'];
}>;


export type EditItemScreenQuery = { __typename?: 'Query', item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, rentingTime?: number | null, rentable?: boolean | null, needsPermit?: boolean | null, emailAdminWhenReturned?: boolean | null, available?: boolean | null, itemGroupId?: string | null, locker?: { __typename?: 'Locker', id: string, name: number, lockersystemId?: string | null, lockerGroup?: { __typename?: 'LockerGroup', id: string, name: string } | null } | null } | null };

export type AllowRentingMutationVariables = Types.Exact<{
  input: Types.AllowRenting;
}>;


export type AllowRentingMutation = { __typename?: 'Mutation', allowRenting: { __typename?: 'AllowRentingResponse', renting?: { __typename?: 'Renting', id: string } | null } };

export type GetLockerQueryVariables = Types.Exact<{
  lockerId: Types.Scalars['ID'];
}>;


export type GetLockerQuery = { __typename?: 'Query', locker?: { __typename?: 'Locker', id: string, name: number, item?: { __typename?: 'Item', id: string, name?: string | null, description?: string | null, imageFileId?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null } | null } | null };

export type RemoveTranslationMutationVariables = Types.Exact<{
  input: Types.RemoveTranslation;
}>;


export type RemoveTranslationMutation = { __typename?: 'Mutation', removeTranslation: { __typename?: 'RemoveTranslationResponse', translationId?: string | null } };

export type SendTestTranslationEmailMutationVariables = Types.Exact<{
  input: Types.SendTestTranslationEmailInput;
}>;


export type SendTestTranslationEmailMutation = { __typename?: 'Mutation', sendTestTranslationEmail: { __typename?: 'SendTestTranslationEmailResponse', success: boolean } };

export type SendRentingLateReminderMutationVariables = Types.Exact<{
  input: Types.SendRentingLateReminderInput;
}>;


export type SendRentingLateReminderMutation = { __typename?: 'Mutation', sendRentingLateReminder: { __typename?: 'SendRentingLateReminderResponse', success: boolean } };

export type SendCustomRentingMessageMutationVariables = Types.Exact<{
  input: Types.SendEmailInput;
}>;


export type SendCustomRentingMessageMutation = { __typename?: 'Mutation', sendEmail: { __typename?: 'SendEmailResponse', emailsSent: number } };

export type DenyLockersystemAccessMutationVariables = Types.Exact<{
  input: Types.DenyLockersystemAccess;
}>;


export type DenyLockersystemAccessMutation = { __typename?: 'Mutation', denyLockersystemAccess: { __typename?: 'DenyLockersystemAccessResponse', permission?: { __typename?: 'LockersystemUserPermission', id?: string | null, isAdmin?: boolean | null, accessDenied?: boolean | null, user?: { __typename?: 'User', id: string, name?: string | null, userName?: string | null, email?: string | null } | null } | null } };

export type AllowLockersystemAccessMutationVariables = Types.Exact<{
  input: Types.AllowLockersystemAccess;
}>;


export type AllowLockersystemAccessMutation = { __typename?: 'Mutation', allowLockersystemAccess: { __typename?: 'AllowLockersystemAccessResponse', permission?: { __typename?: 'LockersystemUserPermission', id?: string | null, isAdmin?: boolean | null, accessDenied?: boolean | null, user?: { __typename?: 'User', id: string, name?: string | null, userName?: string | null, email?: string | null } | null } | null } };

export type CopyItenMutationVariables = Types.Exact<{
  input: Types.CopyItem;
}>;


export type CopyItenMutation = { __typename?: 'Mutation', copyItem: { __typename?: 'CopyItemResponse', item?: { __typename?: 'Item', id: string } | null } };

export type LockersystemUsersQueryVariables = Types.Exact<{
  query: Types.LockersystemUserPermissionsQuery;
}>;


export type LockersystemUsersQuery = { __typename?: 'Query', lockersystemUserPermissions: Array<{ __typename?: 'LockersystemUserPermission', id?: string | null, isAdmin?: boolean | null, accessDenied?: boolean | null, user?: { __typename?: 'User', id: string, name?: string | null, userName?: string | null, email?: string | null } | null }> };

export type TransferUserSearchQueryVariables = Types.Exact<{
  input: Types.UserSearchOptions;
}>;


export type TransferUserSearchQuery = { __typename?: 'Query', users: { __typename?: 'UsersConnection', users: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, userName?: string | null }> } };

export type AdminUserGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, lockersystemId?: string | null, users: Array<{ __typename?: 'User', id: string, name?: string | null, userName?: string | null, email?: string | null }> }> };

export type ItemGroupUserGroupsQueryVariables = Types.Exact<{
  lockersystemId: Types.Scalars['ID'];
}>;


export type ItemGroupUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, lockersystemId?: string | null, users: Array<{ __typename?: 'User', id: string }> }> };

export type CreateUserGroupMutationVariables = Types.Exact<{
  input: Types.CreateUserGroup;
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', createUserGroup: { __typename?: 'CreateUserGroupResponse', userGroup: { __typename?: 'UserGroup', id: string, name: string, lockersystemId?: string | null } } };

export type DeleteUserGroupMutationVariables = Types.Exact<{
  userGroupId: Types.Scalars['ID'];
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutation', deleteUserGroup: boolean };

export type AddUserToUserGroupMutationVariables = Types.Exact<{
  input: Types.UserGroupUserInput;
}>;


export type AddUserToUserGroupMutation = { __typename?: 'Mutation', addUserToUserGroup: boolean };

export type RemoveUserFromUserGroupMutationVariables = Types.Exact<{
  input: Types.UserGroupUserInput;
}>;


export type RemoveUserFromUserGroupMutation = { __typename?: 'Mutation', removeUserFromUserGroup: boolean };

export const AdminViewLockerFragmentDoc = gql`
    fragment AdminViewLocker on Locker {
  id
  name
  width
  height
  depth
  terminal
  item {
    id
    name
    description
    imageFileId
    activeRenting {
      id
      returnItemBefore
      user {
        id
        name
        email
      }
    }
  }
  delivery {
    id
    description
    imageFileId
    pickupBefore
  }
}
    `;
export const AdminViewDocument = gql`
    query AdminView($systemId: ID!) {
  lockersystem(lockersystemId: $systemId) {
    id
    name
    lainaamoTranslations {
      id
      key
      variables
      language
      default
      translation
    }
    lockerGroups(lainaamo: true) {
      lockerUnits {
        id
        lockerNodes {
          id
          leftUpLocker {
            ...AdminViewLocker
          }
          rightUpLocker {
            ...AdminViewLocker
          }
          leftDownLocker {
            ...AdminViewLocker
          }
          rightDownLocker {
            ...AdminViewLocker
          }
          leftUpDoorVisible
          rightUpDoorVisible
          leftDownDoorVisible
          rightDownDoorVisible
        }
      }
      id
      name
      lockers {
        ...AdminViewLocker
      }
    }
    items(options: {}) {
      items {
        id
        name
        rentable
        imageFileId
        activeRenting {
          id
          returnItemBefore
          user {
            name
            userName
            gmail
          }
        }
        locker {
          name
          lockerGroup {
            id
            name
          }
        }
      }
    }
    activeDeliveries {
      deliveries {
        id
        description
        pickupBefore
        useDeliveryCodeBefore
        deliveryCodeUsedAt
        createdAt
        whoCanPickup {
          id
          name
          userName
          email
          identityCode
        }
        userWhoDelivered {
          id
          name
          userName
          email
        }
        locker {
          name
          lockerGroup {
            id
            name
          }
        }
      }
    }
    activeRentings {
      rentings {
        id
        returnItemBefore
        state
        user {
          id
          gmail
          name
          userName
        }
        item {
          name
        }
        locker {
          id
          name
          lockerGroup {
            id
            name
          }
        }
      }
    }
    itemGroups {
      id
      lockersystemId
      name
      maxRentingsPerUser
      maxRentingsPerUserEnabled
    }
  }
}
    ${AdminViewLockerFragmentDoc}`;

/**
 * __useAdminViewQuery__
 *
 * To run a query within a React component, call `useAdminViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminViewQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useAdminViewQuery(baseOptions: Apollo.QueryHookOptions<AdminViewQuery, AdminViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminViewQuery, AdminViewQueryVariables>(AdminViewDocument, options);
      }
export function useAdminViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminViewQuery, AdminViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminViewQuery, AdminViewQueryVariables>(AdminViewDocument, options);
        }
export type AdminViewQueryHookResult = ReturnType<typeof useAdminViewQuery>;
export type AdminViewLazyQueryHookResult = ReturnType<typeof useAdminViewLazyQuery>;
export type AdminViewQueryResult = Apollo.QueryResult<AdminViewQuery, AdminViewQueryVariables>;
export const InterruptDeliveryDocument = gql`
    mutation interruptDelivery($deliveryId: ID!) {
  interruptDelivery(input: {deliveryId: $deliveryId}) {
    delivery {
      id
      pickupCode
      pickupBefore
      usePickupCodeBefore
    }
  }
}
    `;
export type InterruptDeliveryMutationFn = Apollo.MutationFunction<InterruptDeliveryMutation, InterruptDeliveryMutationVariables>;

/**
 * __useInterruptDeliveryMutation__
 *
 * To run a mutation, you first call `useInterruptDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterruptDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interruptDeliveryMutation, { data, loading, error }] = useInterruptDeliveryMutation({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useInterruptDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<InterruptDeliveryMutation, InterruptDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterruptDeliveryMutation, InterruptDeliveryMutationVariables>(InterruptDeliveryDocument, options);
      }
export type InterruptDeliveryMutationHookResult = ReturnType<typeof useInterruptDeliveryMutation>;
export type InterruptDeliveryMutationResult = Apollo.MutationResult<InterruptDeliveryMutation>;
export type InterruptDeliveryMutationOptions = Apollo.BaseMutationOptions<InterruptDeliveryMutation, InterruptDeliveryMutationVariables>;
export const InterruptRentingDocument = gql`
    mutation interruptRenting($rentingId: ID!) {
  interruptRenting(input: {rentingId: $rentingId}) {
    renting {
      id
      returnCode
      returnCodeUsedAt
      useReturnCodeBefore
    }
  }
}
    `;
export type InterruptRentingMutationFn = Apollo.MutationFunction<InterruptRentingMutation, InterruptRentingMutationVariables>;

/**
 * __useInterruptRentingMutation__
 *
 * To run a mutation, you first call `useInterruptRentingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterruptRentingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interruptRentingMutation, { data, loading, error }] = useInterruptRentingMutation({
 *   variables: {
 *      rentingId: // value for 'rentingId'
 *   },
 * });
 */
export function useInterruptRentingMutation(baseOptions?: Apollo.MutationHookOptions<InterruptRentingMutation, InterruptRentingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterruptRentingMutation, InterruptRentingMutationVariables>(InterruptRentingDocument, options);
      }
export type InterruptRentingMutationHookResult = ReturnType<typeof useInterruptRentingMutation>;
export type InterruptRentingMutationResult = Apollo.MutationResult<InterruptRentingMutation>;
export type InterruptRentingMutationOptions = Apollo.BaseMutationOptions<InterruptRentingMutation, InterruptRentingMutationVariables>;
export const PlaceItemToLockerDocument = gql`
    mutation placeItemToLocker($itemId: ID!, $lockerId: ID!) {
  placeItemToLocker(input: {itemId: $itemId, lockerId: $lockerId}) {
    item {
      id
      creationCode
      creationCodeUsedAt
      useCreationCodeBefore
    }
  }
}
    `;
export type PlaceItemToLockerMutationFn = Apollo.MutationFunction<PlaceItemToLockerMutation, PlaceItemToLockerMutationVariables>;

/**
 * __usePlaceItemToLockerMutation__
 *
 * To run a mutation, you first call `usePlaceItemToLockerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceItemToLockerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeItemToLockerMutation, { data, loading, error }] = usePlaceItemToLockerMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      lockerId: // value for 'lockerId'
 *   },
 * });
 */
export function usePlaceItemToLockerMutation(baseOptions?: Apollo.MutationHookOptions<PlaceItemToLockerMutation, PlaceItemToLockerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceItemToLockerMutation, PlaceItemToLockerMutationVariables>(PlaceItemToLockerDocument, options);
      }
export type PlaceItemToLockerMutationHookResult = ReturnType<typeof usePlaceItemToLockerMutation>;
export type PlaceItemToLockerMutationResult = Apollo.MutationResult<PlaceItemToLockerMutation>;
export type PlaceItemToLockerMutationOptions = Apollo.BaseMutationOptions<PlaceItemToLockerMutation, PlaceItemToLockerMutationVariables>;
export const DeleteItemDocument = gql`
    mutation deleteItem($itemId: ID!) {
  deleteItem(input: {itemId: $itemId}) {
    item {
      id
      deletedAt
    }
  }
}
    `;
export type DeleteItemMutationFn = Apollo.MutationFunction<DeleteItemMutation, DeleteItemMutationVariables>;

/**
 * __useDeleteItemMutation__
 *
 * To run a mutation, you first call `useDeleteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemMutation, { data, loading, error }] = useDeleteItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useDeleteItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemMutation, DeleteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemMutation, DeleteItemMutationVariables>(DeleteItemDocument, options);
      }
export type DeleteItemMutationHookResult = ReturnType<typeof useDeleteItemMutation>;
export type DeleteItemMutationResult = Apollo.MutationResult<DeleteItemMutation>;
export type DeleteItemMutationOptions = Apollo.BaseMutationOptions<DeleteItemMutation, DeleteItemMutationVariables>;
export const RemoveItemCodeDocument = gql`
    query RemoveItemCode($itemId: ID!) {
  item(itemId: $itemId) {
    id
    removeCode
    removeCodeUsedAt
    useRemoveCodeBefore
  }
}
    `;

/**
 * __useRemoveItemCodeQuery__
 *
 * To run a query within a React component, call `useRemoveItemCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoveItemCodeQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useRemoveItemCodeQuery(baseOptions: Apollo.QueryHookOptions<RemoveItemCodeQuery, RemoveItemCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoveItemCodeQuery, RemoveItemCodeQueryVariables>(RemoveItemCodeDocument, options);
      }
export function useRemoveItemCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemoveItemCodeQuery, RemoveItemCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoveItemCodeQuery, RemoveItemCodeQueryVariables>(RemoveItemCodeDocument, options);
        }
export type RemoveItemCodeQueryHookResult = ReturnType<typeof useRemoveItemCodeQuery>;
export type RemoveItemCodeLazyQueryHookResult = ReturnType<typeof useRemoveItemCodeLazyQuery>;
export type RemoveItemCodeQueryResult = Apollo.QueryResult<RemoveItemCodeQuery, RemoveItemCodeQueryVariables>;
export const InterruptDeliveryCodeDocument = gql`
    query InterruptDeliveryCode($deliveryId: ID!) {
  delivery(deliveryId: $deliveryId) {
    id
    interruptCode
    interruptCodeUsedAt
    useInterruptCodeBefore
  }
}
    `;

/**
 * __useInterruptDeliveryCodeQuery__
 *
 * To run a query within a React component, call `useInterruptDeliveryCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterruptDeliveryCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterruptDeliveryCodeQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useInterruptDeliveryCodeQuery(baseOptions: Apollo.QueryHookOptions<InterruptDeliveryCodeQuery, InterruptDeliveryCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterruptDeliveryCodeQuery, InterruptDeliveryCodeQueryVariables>(InterruptDeliveryCodeDocument, options);
      }
export function useInterruptDeliveryCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterruptDeliveryCodeQuery, InterruptDeliveryCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterruptDeliveryCodeQuery, InterruptDeliveryCodeQueryVariables>(InterruptDeliveryCodeDocument, options);
        }
export type InterruptDeliveryCodeQueryHookResult = ReturnType<typeof useInterruptDeliveryCodeQuery>;
export type InterruptDeliveryCodeLazyQueryHookResult = ReturnType<typeof useInterruptDeliveryCodeLazyQuery>;
export type InterruptDeliveryCodeQueryResult = Apollo.QueryResult<InterruptDeliveryCodeQuery, InterruptDeliveryCodeQueryVariables>;
export const CreateItemDocument = gql`
    mutation CreateItem($input: CreateItem!) {
  result: createItem(input: $input) {
    item {
      id
      available
      locker {
        id
        item {
          id
        }
      }
    }
  }
}
    `;
export type CreateItemMutationFn = Apollo.MutationFunction<CreateItemMutation, CreateItemMutationVariables>;

/**
 * __useCreateItemMutation__
 *
 * To run a mutation, you first call `useCreateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemMutation, { data, loading, error }] = useCreateItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemMutation, CreateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemMutation, CreateItemMutationVariables>(CreateItemDocument, options);
      }
export type CreateItemMutationHookResult = ReturnType<typeof useCreateItemMutation>;
export type CreateItemMutationResult = Apollo.MutationResult<CreateItemMutation>;
export type CreateItemMutationOptions = Apollo.BaseMutationOptions<CreateItemMutation, CreateItemMutationVariables>;
export const CreateItemCodeDocument = gql`
    query CreateItemCode($itemId: ID!) {
  item(itemId: $itemId) {
    id
    creationCode
    creationCodeUsedAt
    useCreationCodeBefore
  }
}
    `;

/**
 * __useCreateItemCodeQuery__
 *
 * To run a query within a React component, call `useCreateItemCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateItemCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateItemCodeQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useCreateItemCodeQuery(baseOptions: Apollo.QueryHookOptions<CreateItemCodeQuery, CreateItemCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateItemCodeQuery, CreateItemCodeQueryVariables>(CreateItemCodeDocument, options);
      }
export function useCreateItemCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateItemCodeQuery, CreateItemCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateItemCodeQuery, CreateItemCodeQueryVariables>(CreateItemCodeDocument, options);
        }
export type CreateItemCodeQueryHookResult = ReturnType<typeof useCreateItemCodeQuery>;
export type CreateItemCodeLazyQueryHookResult = ReturnType<typeof useCreateItemCodeLazyQuery>;
export type CreateItemCodeQueryResult = Apollo.QueryResult<CreateItemCodeQuery, CreateItemCodeQueryVariables>;
export const UpdateItemDocument = gql`
    mutation updateItem($input: UpdateItem!) {
  updateItem(input: $input) {
    item {
      id
      name
      description
      imageFileId
      rentingTime
      rentable
      needsPermit
      emailAdminWhenReturned
      available
      itemGroupId
      itemGroup {
        id
        name
      }
      locker {
        id
        name
        lockerGroup {
          id
          name
        }
      }
    }
  }
}
    `;
export type UpdateItemMutationFn = Apollo.MutationFunction<UpdateItemMutation, UpdateItemMutationVariables>;

/**
 * __useUpdateItemMutation__
 *
 * To run a mutation, you first call `useUpdateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemMutation, { data, loading, error }] = useUpdateItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemMutation, UpdateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemMutation, UpdateItemMutationVariables>(UpdateItemDocument, options);
      }
export type UpdateItemMutationHookResult = ReturnType<typeof useUpdateItemMutation>;
export type UpdateItemMutationResult = Apollo.MutationResult<UpdateItemMutation>;
export type UpdateItemMutationOptions = Apollo.BaseMutationOptions<UpdateItemMutation, UpdateItemMutationVariables>;
export const ChangeLanguageDocument = gql`
    mutation changeLanguage($input: ChangeLanguage!) {
  changeUserDefaultLanguage(input: $input) {
    user {
      id
      language
    }
  }
}
    `;
export type ChangeLanguageMutationFn = Apollo.MutationFunction<ChangeLanguageMutation, ChangeLanguageMutationVariables>;

/**
 * __useChangeLanguageMutation__
 *
 * To run a mutation, you first call `useChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLanguageMutation, { data, loading, error }] = useChangeLanguageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeLanguageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLanguageMutation, ChangeLanguageMutationVariables>(ChangeLanguageDocument, options);
      }
export type ChangeLanguageMutationHookResult = ReturnType<typeof useChangeLanguageMutation>;
export type ChangeLanguageMutationResult = Apollo.MutationResult<ChangeLanguageMutation>;
export type ChangeLanguageMutationOptions = Apollo.BaseMutationOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>;
export const UpdateTranslationDocument = gql`
    mutation updateTranslation($input: UpdateTranslation!) {
  updateTranslation(input: $input) {
    translation {
      id
      key
      translation
      language
    }
    lockersystemId
  }
}
    `;
export type UpdateTranslationMutationFn = Apollo.MutationFunction<UpdateTranslationMutation, UpdateTranslationMutationVariables>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationMutation, UpdateTranslationMutationVariables>(UpdateTranslationDocument, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<UpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>;
export const UpdateRentingDocument = gql`
    mutation updateRenting($input: UpdateRenting!) {
  updateRenting(input: $input) {
    renting {
      id
      returnItemBefore
    }
  }
}
    `;
export type UpdateRentingMutationFn = Apollo.MutationFunction<UpdateRentingMutation, UpdateRentingMutationVariables>;

/**
 * __useUpdateRentingMutation__
 *
 * To run a mutation, you first call `useUpdateRentingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentingMutation, { data, loading, error }] = useUpdateRentingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRentingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRentingMutation, UpdateRentingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRentingMutation, UpdateRentingMutationVariables>(UpdateRentingDocument, options);
      }
export type UpdateRentingMutationHookResult = ReturnType<typeof useUpdateRentingMutation>;
export type UpdateRentingMutationResult = Apollo.MutationResult<UpdateRentingMutation>;
export type UpdateRentingMutationOptions = Apollo.BaseMutationOptions<UpdateRentingMutation, UpdateRentingMutationVariables>;
export const TransferRentingDocument = gql`
    mutation transferRenting($input: TransferRenting!) {
  transferRenting(input: $input) {
    renting {
      id
      user {
        id
        name
        userName
        gmail
      }
    }
  }
}
    `;
export type TransferRentingMutationFn = Apollo.MutationFunction<TransferRentingMutation, TransferRentingMutationVariables>;

/**
 * __useTransferRentingMutation__
 *
 * To run a mutation, you first call `useTransferRentingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferRentingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferRentingMutation, { data, loading, error }] = useTransferRentingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferRentingMutation(baseOptions?: Apollo.MutationHookOptions<TransferRentingMutation, TransferRentingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferRentingMutation, TransferRentingMutationVariables>(TransferRentingDocument, options);
      }
export type TransferRentingMutationHookResult = ReturnType<typeof useTransferRentingMutation>;
export type TransferRentingMutationResult = Apollo.MutationResult<TransferRentingMutation>;
export type TransferRentingMutationOptions = Apollo.BaseMutationOptions<TransferRentingMutation, TransferRentingMutationVariables>;
export const SearchItemsDocument = gql`
    query searchItems($opt: SearchItemsOptions!) {
  items(opt: $opt) {
    items {
      id
      name
      description
      rentingTime
      rentable
      needsPermit
      emailAdminWhenReturned
      available
      activeRenting {
        id
        returnItemBefore
        permitGiven
        user {
          name
          userName
          gmail
        }
      }
      itemGroup {
        id
        name
      }
      locker {
        id
        name
        lockerGroup {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchItemsQuery__
 *
 * To run a query within a React component, call `useSearchItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchItemsQuery({
 *   variables: {
 *      opt: // value for 'opt'
 *   },
 * });
 */
export function useSearchItemsQuery(baseOptions: Apollo.QueryHookOptions<SearchItemsQuery, SearchItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchItemsQuery, SearchItemsQueryVariables>(SearchItemsDocument, options);
      }
export function useSearchItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchItemsQuery, SearchItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchItemsQuery, SearchItemsQueryVariables>(SearchItemsDocument, options);
        }
export type SearchItemsQueryHookResult = ReturnType<typeof useSearchItemsQuery>;
export type SearchItemsLazyQueryHookResult = ReturnType<typeof useSearchItemsLazyQuery>;
export type SearchItemsQueryResult = Apollo.QueryResult<SearchItemsQuery, SearchItemsQueryVariables>;
export const GivePermitDocument = gql`
    mutation givePermit($input: GivePermit!) {
  givePermit(input: $input) {
    renting {
      id
      state
    }
  }
}
    `;
export type GivePermitMutationFn = Apollo.MutationFunction<GivePermitMutation, GivePermitMutationVariables>;

/**
 * __useGivePermitMutation__
 *
 * To run a mutation, you first call `useGivePermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGivePermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [givePermitMutation, { data, loading, error }] = useGivePermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGivePermitMutation(baseOptions?: Apollo.MutationHookOptions<GivePermitMutation, GivePermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GivePermitMutation, GivePermitMutationVariables>(GivePermitDocument, options);
      }
export type GivePermitMutationHookResult = ReturnType<typeof useGivePermitMutation>;
export type GivePermitMutationResult = Apollo.MutationResult<GivePermitMutation>;
export type GivePermitMutationOptions = Apollo.BaseMutationOptions<GivePermitMutation, GivePermitMutationVariables>;
export const DeclinePermitDocument = gql`
    mutation declinePermit($input: DeclinePermit!) {
  declinePermit(input: $input) {
    renting {
      id
      state
    }
  }
}
    `;
export type DeclinePermitMutationFn = Apollo.MutationFunction<DeclinePermitMutation, DeclinePermitMutationVariables>;

/**
 * __useDeclinePermitMutation__
 *
 * To run a mutation, you first call `useDeclinePermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclinePermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declinePermitMutation, { data, loading, error }] = useDeclinePermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclinePermitMutation(baseOptions?: Apollo.MutationHookOptions<DeclinePermitMutation, DeclinePermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclinePermitMutation, DeclinePermitMutationVariables>(DeclinePermitDocument, options);
      }
export type DeclinePermitMutationHookResult = ReturnType<typeof useDeclinePermitMutation>;
export type DeclinePermitMutationResult = Apollo.MutationResult<DeclinePermitMutation>;
export type DeclinePermitMutationOptions = Apollo.BaseMutationOptions<DeclinePermitMutation, DeclinePermitMutationVariables>;
export const EditItemScreenDocument = gql`
    query EditItemScreen($itemId: ID!) {
  item(itemId: $itemId) {
    id
    name
    description
    imageFileId
    rentingTime
    rentable
    needsPermit
    emailAdminWhenReturned
    available
    itemGroupId
    locker {
      id
      name
      lockersystemId
      lockerGroup {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useEditItemScreenQuery__
 *
 * To run a query within a React component, call `useEditItemScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditItemScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditItemScreenQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useEditItemScreenQuery(baseOptions: Apollo.QueryHookOptions<EditItemScreenQuery, EditItemScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditItemScreenQuery, EditItemScreenQueryVariables>(EditItemScreenDocument, options);
      }
export function useEditItemScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditItemScreenQuery, EditItemScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditItemScreenQuery, EditItemScreenQueryVariables>(EditItemScreenDocument, options);
        }
export type EditItemScreenQueryHookResult = ReturnType<typeof useEditItemScreenQuery>;
export type EditItemScreenLazyQueryHookResult = ReturnType<typeof useEditItemScreenLazyQuery>;
export type EditItemScreenQueryResult = Apollo.QueryResult<EditItemScreenQuery, EditItemScreenQueryVariables>;
export const AllowRentingDocument = gql`
    mutation allowRenting($input: AllowRenting!) {
  allowRenting(input: $input) {
    renting {
      id
    }
  }
}
    `;
export type AllowRentingMutationFn = Apollo.MutationFunction<AllowRentingMutation, AllowRentingMutationVariables>;

/**
 * __useAllowRentingMutation__
 *
 * To run a mutation, you first call `useAllowRentingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowRentingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowRentingMutation, { data, loading, error }] = useAllowRentingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllowRentingMutation(baseOptions?: Apollo.MutationHookOptions<AllowRentingMutation, AllowRentingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllowRentingMutation, AllowRentingMutationVariables>(AllowRentingDocument, options);
      }
export type AllowRentingMutationHookResult = ReturnType<typeof useAllowRentingMutation>;
export type AllowRentingMutationResult = Apollo.MutationResult<AllowRentingMutation>;
export type AllowRentingMutationOptions = Apollo.BaseMutationOptions<AllowRentingMutation, AllowRentingMutationVariables>;
export const GetLockerDocument = gql`
    query getLocker($lockerId: ID!) {
  locker(lockerId: $lockerId) {
    id
    name
    item {
      id
      name
      description
      imageFileId
      activeRenting {
        id
        returnItemBefore
        user {
          id
          name
          email
        }
      }
    }
    delivery {
      id
      description
      pickupBefore
    }
  }
}
    `;

/**
 * __useGetLockerQuery__
 *
 * To run a query within a React component, call `useGetLockerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLockerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLockerQuery({
 *   variables: {
 *      lockerId: // value for 'lockerId'
 *   },
 * });
 */
export function useGetLockerQuery(baseOptions: Apollo.QueryHookOptions<GetLockerQuery, GetLockerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLockerQuery, GetLockerQueryVariables>(GetLockerDocument, options);
      }
export function useGetLockerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLockerQuery, GetLockerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLockerQuery, GetLockerQueryVariables>(GetLockerDocument, options);
        }
export type GetLockerQueryHookResult = ReturnType<typeof useGetLockerQuery>;
export type GetLockerLazyQueryHookResult = ReturnType<typeof useGetLockerLazyQuery>;
export type GetLockerQueryResult = Apollo.QueryResult<GetLockerQuery, GetLockerQueryVariables>;
export const RemoveTranslationDocument = gql`
    mutation removeTranslation($input: RemoveTranslation!) {
  removeTranslation(input: $input) {
    translationId
  }
}
    `;
export type RemoveTranslationMutationFn = Apollo.MutationFunction<RemoveTranslationMutation, RemoveTranslationMutationVariables>;

/**
 * __useRemoveTranslationMutation__
 *
 * To run a mutation, you first call `useRemoveTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTranslationMutation, { data, loading, error }] = useRemoveTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTranslationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTranslationMutation, RemoveTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTranslationMutation, RemoveTranslationMutationVariables>(RemoveTranslationDocument, options);
      }
export type RemoveTranslationMutationHookResult = ReturnType<typeof useRemoveTranslationMutation>;
export type RemoveTranslationMutationResult = Apollo.MutationResult<RemoveTranslationMutation>;
export type RemoveTranslationMutationOptions = Apollo.BaseMutationOptions<RemoveTranslationMutation, RemoveTranslationMutationVariables>;
export const SendTestTranslationEmailDocument = gql`
    mutation sendTestTranslationEmail($input: SendTestTranslationEmailInput!) {
  sendTestTranslationEmail(input: $input) {
    success
  }
}
    `;
export type SendTestTranslationEmailMutationFn = Apollo.MutationFunction<SendTestTranslationEmailMutation, SendTestTranslationEmailMutationVariables>;

/**
 * __useSendTestTranslationEmailMutation__
 *
 * To run a mutation, you first call `useSendTestTranslationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestTranslationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestTranslationEmailMutation, { data, loading, error }] = useSendTestTranslationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestTranslationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestTranslationEmailMutation, SendTestTranslationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestTranslationEmailMutation, SendTestTranslationEmailMutationVariables>(SendTestTranslationEmailDocument, options);
      }
export type SendTestTranslationEmailMutationHookResult = ReturnType<typeof useSendTestTranslationEmailMutation>;
export type SendTestTranslationEmailMutationResult = Apollo.MutationResult<SendTestTranslationEmailMutation>;
export type SendTestTranslationEmailMutationOptions = Apollo.BaseMutationOptions<SendTestTranslationEmailMutation, SendTestTranslationEmailMutationVariables>;
export const SendRentingLateReminderDocument = gql`
    mutation sendRentingLateReminder($input: SendRentingLateReminderInput!) {
  sendRentingLateReminder(input: $input) {
    success
  }
}
    `;
export type SendRentingLateReminderMutationFn = Apollo.MutationFunction<SendRentingLateReminderMutation, SendRentingLateReminderMutationVariables>;

/**
 * __useSendRentingLateReminderMutation__
 *
 * To run a mutation, you first call `useSendRentingLateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRentingLateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRentingLateReminderMutation, { data, loading, error }] = useSendRentingLateReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendRentingLateReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendRentingLateReminderMutation, SendRentingLateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRentingLateReminderMutation, SendRentingLateReminderMutationVariables>(SendRentingLateReminderDocument, options);
      }
export type SendRentingLateReminderMutationHookResult = ReturnType<typeof useSendRentingLateReminderMutation>;
export type SendRentingLateReminderMutationResult = Apollo.MutationResult<SendRentingLateReminderMutation>;
export type SendRentingLateReminderMutationOptions = Apollo.BaseMutationOptions<SendRentingLateReminderMutation, SendRentingLateReminderMutationVariables>;
export const SendCustomRentingMessageDocument = gql`
    mutation sendCustomRentingMessage($input: SendEmailInput!) {
  sendEmail(input: $input) {
    emailsSent
  }
}
    `;
export type SendCustomRentingMessageMutationFn = Apollo.MutationFunction<SendCustomRentingMessageMutation, SendCustomRentingMessageMutationVariables>;

/**
 * __useSendCustomRentingMessageMutation__
 *
 * To run a mutation, you first call `useSendCustomRentingMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomRentingMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomRentingMessageMutation, { data, loading, error }] = useSendCustomRentingMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCustomRentingMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendCustomRentingMessageMutation, SendCustomRentingMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCustomRentingMessageMutation, SendCustomRentingMessageMutationVariables>(SendCustomRentingMessageDocument, options);
      }
export type SendCustomRentingMessageMutationHookResult = ReturnType<typeof useSendCustomRentingMessageMutation>;
export type SendCustomRentingMessageMutationResult = Apollo.MutationResult<SendCustomRentingMessageMutation>;
export type SendCustomRentingMessageMutationOptions = Apollo.BaseMutationOptions<SendCustomRentingMessageMutation, SendCustomRentingMessageMutationVariables>;
export const DenyLockersystemAccessDocument = gql`
    mutation denyLockersystemAccess($input: DenyLockersystemAccess!) {
  denyLockersystemAccess(input: $input) {
    permission {
      id
      user {
        id
        name
        userName
        email
      }
      isAdmin
      accessDenied
    }
  }
}
    `;
export type DenyLockersystemAccessMutationFn = Apollo.MutationFunction<DenyLockersystemAccessMutation, DenyLockersystemAccessMutationVariables>;

/**
 * __useDenyLockersystemAccessMutation__
 *
 * To run a mutation, you first call `useDenyLockersystemAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyLockersystemAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyLockersystemAccessMutation, { data, loading, error }] = useDenyLockersystemAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDenyLockersystemAccessMutation(baseOptions?: Apollo.MutationHookOptions<DenyLockersystemAccessMutation, DenyLockersystemAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyLockersystemAccessMutation, DenyLockersystemAccessMutationVariables>(DenyLockersystemAccessDocument, options);
      }
export type DenyLockersystemAccessMutationHookResult = ReturnType<typeof useDenyLockersystemAccessMutation>;
export type DenyLockersystemAccessMutationResult = Apollo.MutationResult<DenyLockersystemAccessMutation>;
export type DenyLockersystemAccessMutationOptions = Apollo.BaseMutationOptions<DenyLockersystemAccessMutation, DenyLockersystemAccessMutationVariables>;
export const AllowLockersystemAccessDocument = gql`
    mutation allowLockersystemAccess($input: AllowLockersystemAccess!) {
  allowLockersystemAccess(input: $input) {
    permission {
      id
      user {
        id
        name
        userName
        email
      }
      isAdmin
      accessDenied
    }
  }
}
    `;
export type AllowLockersystemAccessMutationFn = Apollo.MutationFunction<AllowLockersystemAccessMutation, AllowLockersystemAccessMutationVariables>;

/**
 * __useAllowLockersystemAccessMutation__
 *
 * To run a mutation, you first call `useAllowLockersystemAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowLockersystemAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowLockersystemAccessMutation, { data, loading, error }] = useAllowLockersystemAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllowLockersystemAccessMutation(baseOptions?: Apollo.MutationHookOptions<AllowLockersystemAccessMutation, AllowLockersystemAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllowLockersystemAccessMutation, AllowLockersystemAccessMutationVariables>(AllowLockersystemAccessDocument, options);
      }
export type AllowLockersystemAccessMutationHookResult = ReturnType<typeof useAllowLockersystemAccessMutation>;
export type AllowLockersystemAccessMutationResult = Apollo.MutationResult<AllowLockersystemAccessMutation>;
export type AllowLockersystemAccessMutationOptions = Apollo.BaseMutationOptions<AllowLockersystemAccessMutation, AllowLockersystemAccessMutationVariables>;
export const CopyItenDocument = gql`
    mutation copyIten($input: CopyItem!) {
  copyItem(input: $input) {
    item {
      id
    }
  }
}
    `;
export type CopyItenMutationFn = Apollo.MutationFunction<CopyItenMutation, CopyItenMutationVariables>;

/**
 * __useCopyItenMutation__
 *
 * To run a mutation, you first call `useCopyItenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyItenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyItenMutation, { data, loading, error }] = useCopyItenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyItenMutation(baseOptions?: Apollo.MutationHookOptions<CopyItenMutation, CopyItenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyItenMutation, CopyItenMutationVariables>(CopyItenDocument, options);
      }
export type CopyItenMutationHookResult = ReturnType<typeof useCopyItenMutation>;
export type CopyItenMutationResult = Apollo.MutationResult<CopyItenMutation>;
export type CopyItenMutationOptions = Apollo.BaseMutationOptions<CopyItenMutation, CopyItenMutationVariables>;
export const LockersystemUsersDocument = gql`
    query lockersystemUsers($query: LockersystemUserPermissionsQuery!) {
  lockersystemUserPermissions(query: $query) {
    id
    user {
      id
      name
      userName
      email
    }
    isAdmin
    accessDenied
  }
}
    `;

/**
 * __useLockersystemUsersQuery__
 *
 * To run a query within a React component, call `useLockersystemUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLockersystemUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLockersystemUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useLockersystemUsersQuery(baseOptions: Apollo.QueryHookOptions<LockersystemUsersQuery, LockersystemUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LockersystemUsersQuery, LockersystemUsersQueryVariables>(LockersystemUsersDocument, options);
      }
export function useLockersystemUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LockersystemUsersQuery, LockersystemUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LockersystemUsersQuery, LockersystemUsersQueryVariables>(LockersystemUsersDocument, options);
        }
export type LockersystemUsersQueryHookResult = ReturnType<typeof useLockersystemUsersQuery>;
export type LockersystemUsersLazyQueryHookResult = ReturnType<typeof useLockersystemUsersLazyQuery>;
export type LockersystemUsersQueryResult = Apollo.QueryResult<LockersystemUsersQuery, LockersystemUsersQueryVariables>;
export const TransferUserSearchDocument = gql`
    query TransferUserSearch($input: UserSearchOptions!) {
  users(input: $input) {
    users {
      id
      name
      email
      userName
    }
  }
}
    `;

/**
 * __useTransferUserSearchQuery__
 *
 * To run a query within a React component, call `useTransferUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferUserSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferUserSearchQuery(baseOptions: Apollo.QueryHookOptions<TransferUserSearchQuery, TransferUserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferUserSearchQuery, TransferUserSearchQueryVariables>(TransferUserSearchDocument, options);
      }
export function useTransferUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferUserSearchQuery, TransferUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferUserSearchQuery, TransferUserSearchQueryVariables>(TransferUserSearchDocument, options);
        }
export type TransferUserSearchQueryHookResult = ReturnType<typeof useTransferUserSearchQuery>;
export type TransferUserSearchLazyQueryHookResult = ReturnType<typeof useTransferUserSearchLazyQuery>;
export type TransferUserSearchQueryResult = Apollo.QueryResult<TransferUserSearchQuery, TransferUserSearchQueryVariables>;
export const AdminUserGroupsDocument = gql`
    query adminUserGroups {
  userGroups {
    id
    name
    lockersystemId
    users {
      id
      name
      userName
      email
    }
  }
}
    `;

/**
 * __useAdminUserGroupsQuery__
 *
 * To run a query within a React component, call `useAdminUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AdminUserGroupsQuery, AdminUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserGroupsQuery, AdminUserGroupsQueryVariables>(AdminUserGroupsDocument, options);
      }
export function useAdminUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserGroupsQuery, AdminUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserGroupsQuery, AdminUserGroupsQueryVariables>(AdminUserGroupsDocument, options);
        }
export type AdminUserGroupsQueryHookResult = ReturnType<typeof useAdminUserGroupsQuery>;
export type AdminUserGroupsLazyQueryHookResult = ReturnType<typeof useAdminUserGroupsLazyQuery>;
export type AdminUserGroupsQueryResult = Apollo.QueryResult<AdminUserGroupsQuery, AdminUserGroupsQueryVariables>;
export const ItemGroupUserGroupsDocument = gql`
    query itemGroupUserGroups($lockersystemId: ID!) {
  userGroups(lockersystemId: $lockersystemId) {
    id
    name
    lockersystemId
    users {
      id
    }
  }
}
    `;

/**
 * __useItemGroupUserGroupsQuery__
 *
 * To run a query within a React component, call `useItemGroupUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemGroupUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemGroupUserGroupsQuery({
 *   variables: {
 *      lockersystemId: // value for 'lockersystemId'
 *   },
 * });
 */
export function useItemGroupUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<ItemGroupUserGroupsQuery, ItemGroupUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemGroupUserGroupsQuery, ItemGroupUserGroupsQueryVariables>(ItemGroupUserGroupsDocument, options);
      }
export function useItemGroupUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemGroupUserGroupsQuery, ItemGroupUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemGroupUserGroupsQuery, ItemGroupUserGroupsQueryVariables>(ItemGroupUserGroupsDocument, options);
        }
export type ItemGroupUserGroupsQueryHookResult = ReturnType<typeof useItemGroupUserGroupsQuery>;
export type ItemGroupUserGroupsLazyQueryHookResult = ReturnType<typeof useItemGroupUserGroupsLazyQuery>;
export type ItemGroupUserGroupsQueryResult = Apollo.QueryResult<ItemGroupUserGroupsQuery, ItemGroupUserGroupsQueryVariables>;
export const CreateUserGroupDocument = gql`
    mutation createUserGroup($input: CreateUserGroup!) {
  createUserGroup(input: $input) {
    userGroup {
      id
      name
      lockersystemId
    }
  }
}
    `;
export type CreateUserGroupMutationFn = Apollo.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, options);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = Apollo.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const DeleteUserGroupDocument = gql`
    mutation deleteUserGroup($userGroupId: ID!) {
  deleteUserGroup(userGroupId: $userGroupId)
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const AddUserToUserGroupDocument = gql`
    mutation addUserToUserGroup($input: UserGroupUserInput!) {
  addUserToUserGroup(input: $input)
}
    `;
export type AddUserToUserGroupMutationFn = Apollo.MutationFunction<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>;

/**
 * __useAddUserToUserGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToUserGroupMutation, { data, loading, error }] = useAddUserToUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>(AddUserToUserGroupDocument, options);
      }
export type AddUserToUserGroupMutationHookResult = ReturnType<typeof useAddUserToUserGroupMutation>;
export type AddUserToUserGroupMutationResult = Apollo.MutationResult<AddUserToUserGroupMutation>;
export type AddUserToUserGroupMutationOptions = Apollo.BaseMutationOptions<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>;
export const RemoveUserFromUserGroupDocument = gql`
    mutation removeUserFromUserGroup($input: UserGroupUserInput!) {
  removeUserFromUserGroup(input: $input)
}
    `;
export type RemoveUserFromUserGroupMutationFn = Apollo.MutationFunction<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>;

/**
 * __useRemoveUserFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromUserGroupMutation, { data, loading, error }] = useRemoveUserFromUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserFromUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>(RemoveUserFromUserGroupDocument, options);
      }
export type RemoveUserFromUserGroupMutationHookResult = ReturnType<typeof useRemoveUserFromUserGroupMutation>;
export type RemoveUserFromUserGroupMutationResult = Apollo.MutationResult<RemoveUserFromUserGroupMutation>;
export type RemoveUserFromUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>;